import { lumi } from '@/lib/lumi'
import { useCallback, useState } from 'react'

export interface Publication {
  _id: string
  title: string
  category: string
  description: string
  tag?: string
  fileUrl?: string
  coverUrl?: string
  publishedDate?: string
  status: 'draft' | 'published'
  order?: number
  creator: string
  createdAt: string
  updatedAt: string
}

export function usePublications() {
  const [publications, setPublications] = useState<Publication[]>([])
  const [loading, setLoading] = useState(false)

  const fetchPublications = useCallback(async (onlyPublished = false) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.publications.list({
        filter: onlyPublished ? { status: 'published' } : {},
        sort: { order: 1, createdAt: -1 },
      })
      setPublications(list as Publication[])
    } catch (error) {
      console.error('Échec du chargement des publications:', error)
    } finally {
      setLoading(false)
    }
  }, [])

  const createPublication = useCallback(async (data: Partial<Publication>) => {
    const now = new Date().toISOString()
    const created = await lumi.entities.publications.create({
      ...data,
      createdAt: now,
      updatedAt: now,
    })
    return created
  }, [])

  const updatePublication = useCallback(async (id: string, data: Partial<Publication>) => {
    const updated = await lumi.entities.publications.update(id, {
      ...data,
      updatedAt: new Date().toISOString(),
    })
    return updated
  }, [])

  const deletePublication = useCallback(async (id: string) => {
    await lumi.entities.publications.delete(id)
  }, [])

  return {
    publications,
    loading,
    fetchPublications,
    createPublication,
    updatePublication,
    deletePublication,
  }
}
